var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"8","sm":"6"}},[_c('v-autocomplete',{attrs:{"name":"partner","items":_vm.partners,"label":_vm.$t('manual_order.select_partner'),"item-text":(item) =>
            `${item.company ? item.company.name : null} - ${item.forename} ${
              item.surname
            } (${item.email})`,"item-value":"id","justify":"start"},on:{"change":function($event){return _vm.setPartner($event)}},model:{value:(_vm.partner),callback:function ($$v) {_vm.partner=$$v},expression:"partner"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }